import { AnimatePresence } from "framer-motion";
import { ArrowRight, Check, ClipboardCheck } from "lucide-react";
import { ColorHeader, ModalFrame, ghostBtn, primaryBtn } from "./FormBits";

export const ChecklistModal = ({ open, onClose, content, questions, checks, setChecks, onComplete }) => {
  const done = checks.filter(Boolean).length;
  return (
    <AnimatePresence>
      {open && (
        <ModalFrame testId="checklist-modal" onClose={onClose} zIndex={80}>
          <ColorHeader step={1} kicker="Before you register" title={content?.checklist_title || "Please confirm the following before registering"} sub={content?.checklist_subtitle || "Please tick all to continue."} onClose={onClose} closeTestId="checklist-close" icon={<ClipboardCheck size={20} />} />
          <div className="px-5 sm:px-8 py-6">
            <div className="flex items-center justify-between mb-3">
              <p className="text-[10px] uppercase tracking-widest text-[#2F6B4F] font-semibold">Your commitments</p>
              <span data-testid="checklist-progress" className={`rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${done === questions.length ? "bg-emerald-100 text-emerald-800" : "bg-[#F4F1EA] text-[#1A2E26]/70"}`}>{done} of {questions.length} ticked</span>
            </div>
            <div className="h-1.5 rounded-full bg-[#1A2E26]/10 overflow-hidden mb-4"><div className="h-full rounded-full bg-gradient-to-r from-[#2F6B4F] to-[#9DBBA8] transition-[width] duration-300" style={{ width: `${questions.length ? (done / questions.length) * 100 : 0}%` }} /></div>
            <div className="space-y-2.5">
              {questions.map((q, idx) => {
                const on = checks[idx] || false;
                return (
                  <label key={idx} data-testid={`checklist-item-${idx}`} className={`flex items-start gap-3 cursor-pointer rounded-2xl border p-3.5 transition-colors ${on ? "border-[#2F6B4F]/40 bg-[#EAF6EE]" : "border-[#1A2E26]/10 bg-white hover:bg-[#F4F1EA]"}`}>
                    <span className="relative mt-0.5 shrink-0">
                      <input type="checkbox" data-testid={`checklist-checkbox-${idx}`} checked={on} onChange={(e) => setChecks((c) => { const n = [...c]; n[idx] = e.target.checked; return n; })} className="peer sr-only" />
                      <span className={`grid place-items-center w-6 h-6 rounded-lg border-2 transition-colors ${on ? "bg-[#2F6B4F] border-[#2F6B4F] text-white" : "border-[#1A2E26]/25 bg-white"}`}>{on && <Check size={14} />}</span>
                    </span>
                    <span className="text-sm leading-relaxed text-[#1A2E26]"><span className="mr-2 inline-grid place-items-center w-5 h-5 rounded-full bg-[#1A2E26]/5 text-[10px] font-bold text-[#1A2E26]/70 align-middle">{idx + 1}</span>{q}</span>
                  </label>
                );
              })}
            </div>
            <div className="mt-6 flex gap-3">
              <button type="button" data-testid="checklist-not-ready" onClick={onClose} className={`${ghostBtn} flex-1 text-muted-foreground`}>Not Yet Ready</button>
              <button data-testid="checklist-continue" onClick={onComplete} disabled={!checks.every(Boolean)} className={`${primaryBtn} flex-1 disabled:cursor-not-allowed`}>
                Agree &amp; continue <ArrowRight size={16} className="group-hover:translate-x-0.5 transition-transform" />
              </button>
            </div>
          </div>
        </ModalFrame>
      )}
    </AnimatePresence>
  );
};
